import type { Product, ProductInput } from '../types';
import { apiClient } from './client';
import type { ListProductsResult, Product as WireProduct } from '@jobmate/types'; // #67 shared-types

export const products = {
  search: async (q: string): Promise<Product[]> => {
    // Wire type: ListProductsResult. After unit_price: number fix, WireProduct is structurally
    // assignable to local Product — no cast needed.
    const { data } = await apiClient.get<ListProductsResult>('/api/products', { params: { q } });
    return data.products as Product[];
  },

  list: async (params?: { page?: number; pageSize?: number }): Promise<Product[]> => {
    // Backend reads `limit` and `offset` — convert from page/pageSize
    const limit = params?.pageSize;
    const offset = params?.page != null && params?.pageSize != null
      ? params.page * params.pageSize
      : undefined;
    const { data } = await apiClient.get<ListProductsResult>('/api/products', { params: { limit, offset } });
    return data.products as Product[];
  },

  create: async (input: ProductInput): Promise<Product> => {
    const { data } = await apiClient.post<WireProduct>('/api/products', input);
    return data as Product;
  },

  update: async (id: number, input: Partial<ProductInput>): Promise<Product> => {
    const { data } = await apiClient.patch<WireProduct>(`/api/products/${id}`, input);
    return data as Product;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/products/${id}`);
  },
};
